module.exports = __webpack_public_path__ + "files/83370b07d64eadd9f399cc641dd7038c.png";